import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';

import {ApplicationState} from '../../application-state/store';
import {StorageLocationsActions} from '../store';
import {StorageLocationsSelectors} from '../store/selectors';

@Injectable()
export class StorageLocationsLoadedGuard implements CanActivate {

  constructor(private store: Store<ApplicationState>) {
  }

  canActivate(): Observable<boolean> {

    return this.loadCustomerDone().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  loadCustomerDone() {

    return this.store.pipe(
      select(StorageLocationsSelectors.isLoaded),
      tap((loaded: boolean) => {
        if (!loaded) {
          this.store.dispatch(StorageLocationsActions.ReadStorageLocations({page: 1}));
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
